<template>
    <section class="nav" style="display:block;">
    <div class="nav_wrap">
      <div class="nav_flex">
        <div class="nav-left-div">
          <a href="#" class="link-block w-inline-block"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-544"></a>
          
        </div>
        <div class="nav-right-div">
          <a href="#" class="nav-button w-button" @click.prevent="logoutUser()">Log Out</a>
        </div>
      </div>
      
    </div>
    <div class="nav-shadow"></div>
    <div class="mobile-nav-div">
      <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar home w-nav">
        <a href="#" class="brand home w-nav-brand"><img src="@/assets/images/OhMyMeds_Logo.svg" loading="lazy" alt="" class="image-550"></a>
        
        <div class="menu-button home w-nav-button">
          <div class="nav-right-div">
            <a href="#" class="nav-button w-button" @click.prevent="logoutUser()">Log Out</a>
          </div>
        </div>
      </div>
      <div class="div-block-1958"></div>
    </div>
  </section>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';


export default {
  name: 'ProductPage',
  data() {
    return {
      lightboxOpen: false,
      product: null,
      currentImageIndex: 0,
      activeDropdown: null,
      error: null,
      isLoading: true,
      openDropdown: null,
      openMenu: false,
      baseUrl: process.env.VUE_APP_API_ENDPOINT
    };
  },
  computed: {
    ...mapGetters([
      'isCartOpen',
      'cartItemCount'
    ]),
    isLoggedin() {
        return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    ...mapActions([
      'setCartVisibility'
    ]),
    
    
    toggleCart() {
      this.setCartVisibility(!this.isCartOpen);
    },
   
    toggleDropdown(index) {
      this.openDropdown = this.openDropdown === index ? null : index;
    },

    logoutUser(){
       
            this.$axios.get(this.baseUrl + '/api/logout').then(response => {
                if (response.data.status == 'success') {
                    localStorage.removeItem('_ymain_key_');
                    window.location.reload();
                }
            }).catch(error => {
                console.log(error);
                localStorage.removeItem('_ymain_key_');
                window.location.reload();
            });
    },
    handleImageError(event) {
      // Replace broken images with a placeholder
      event.target.src = '/@/assets/@/assets/images/placeholder.jpg';
    }
  },
  created() {
    
  },
  
};
</script>
<style scoped>
.light-video {
  width: 100% !important;
  height: 100% !important;
}
.open-menu{
  display: block !important;
}
.div-block-1714 {
        margin-bottom: 10px;
    }
</style>